import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-shared-action-bar',
    templateUrl: './shared-action-bar.component.html',
    styleUrl: './shared-action-bar.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, RouterModule]
})
export class SharedActionBarComponent {

  @Input() saveReady: boolean = false;
  @Input() undoReady: boolean = false;
  @Input() displayActionSectionBar: boolean = false;
  @Input() alternativeBackDestination: string = "/settings";
  @Output() saveRequest: EventEmitter<any> = new EventEmitter();
  @Output() undoRequest: EventEmitter<any> = new EventEmitter();
  @Output() localBack: EventEmitter<any> = new EventEmitter();
  constructor(private router: Router) { }

  saveTriggered() {
    this.saveRequest.emit();
  }
  undoTriggered() {
    this.undoRequest.emit();
  }
  goBack() {
    if(this.alternativeBackDestination.length == 0){
      this.router.navigateByUrl("/settings")
    }
    else if (this.alternativeBackDestination == 'return') {
      this.localBack.emit();
    } else {
      this.router.navigateByUrl(this.alternativeBackDestination);
    }

  }
}
